import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { AppConstant } from 'src/app/utilities/app.constants';
import { DatePipe } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class FilterService {
	csvSubject: Subject<string> = new Subject();
	filterPoolSubject = new BehaviorSubject<any>([]);
	analyticsSubject = new BehaviorSubject<any>([]);
	emailSubject: Subject<string> = new Subject();
	emailCrewListSubject: Subject<string> = new Subject();
	constructor(public datepipe: DatePipe) { }

	addHeaderAndFooterAnalytics(pdfObject, crewobj) {
		var number_of_pages = pdfObject.internal.getNumberOfPages();
		var pdf_pages = pdfObject.internal.pages;
		const todayDate = new Date();
		const date = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
		for (var i = 1; i < pdf_pages.length; i++) {
			// We are telling our pdfObject that we are now working on this page
			pdfObject.setPage(i);
			pdfObject.text(date, 175, 270);
			pdfObject.text(crewobj.crewId, 24, 40);
			pdfObject.text(crewobj.crewName, 21, 50);
			pdfObject.text(crewobj.Rank, 20, 60);
			pdfObject.text(crewobj.Department, 113, 60);
			pdfObject.text(crewobj.Category, 174, 60);
			pdfObject.text(crewobj.no_of_reports, 40, 70);
			pdfObject.text(crewobj.no_of_ships, 115, 70);
			pdfObject.text(crewobj.avgRating, 196, 70);
			pdfObject.setFontType('bold');
			pdfObject.text('Downloaded on Date:', 127, 270);
			pdfObject.text('Crew ID :',5, 40);
			pdfObject.text('Name :',5, 50);
			pdfObject.text('Rank :',5, 60);
			pdfObject.text('Department :',85,60);
			pdfObject.text('Category :',150,60);
			pdfObject.text('No. of Reports :',5,70);
			pdfObject.text('No. of Ships :',85,70);
			pdfObject.text('Average Safety Rating :',145,70);
			pdfObject.text(AppConstant.HEADER_TEXT, 22, 15);
			pdfObject.text(crewobj.featureName, 175, 15);
			pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
			pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
			pdfObject.text('Page ' + i + '/' + number_of_pages,
				pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
		}
		return pdfObject;
	}

	addRatingDescription(DesObject) {
		var number_of_pages = DesObject.internal.getNumberOfPages();
		var pdf_pages = DesObject.internal.pages;
		var table_height = DesObject.autoTable.previous.finalY;
		for (var i = 1; i < pdf_pages.length; i++) {
			// We are telling our pdfObject that we are now working on this page
			DesObject.setPage(i);
			if (i == number_of_pages) {
				DesObject.setFontSize(10)
				DesObject.setFontType('unbold');
				DesObject.text(' Unsatisfied', 10, table_height + 13);
				DesObject.text(' Needs Improvements', 10, table_height + 18);
				DesObject.text(' Meets Expectations', 10, table_height + 23);
				DesObject.text(' Exceeds Expectations', 10, table_height + 28);
				DesObject.text(' Exceptional', 10, table_height + 33);
				DesObject.setFontType('bold');
				DesObject.text('Rating Scale:-', 5, table_height + 8);
				DesObject.text('1 :', 5, table_height + 13);
				DesObject.text('2 :', 5, table_height + 18);
				DesObject.text('3 :', 5, table_height + 23);
				DesObject.text('4 :', 5, table_height + 28);
				DesObject.text('5 :', 5, table_height + 33);
			}
		}
		return DesObject;
	}
}
